<template>
  <div class="piano-control piano-external-cost-control row align-items-baseline">
    <div class="col-auto">
      <FormLabel class="section-title" label-is-fake>{{ label }}</FormLabel>
    </div>
    <div class="col-12 mb-3">
      <button class="btn btn-primary" type="button" @click.prevent="addCost">Aggiungi costo</button>
      <button v-if="libraryCosts.length > 0" class="btn btn-secondary ml-3" type="button" @click.prevent="addCostFromLibrary">Aggiungi costo da libreria</button>
    </div>
    <template v-for="(cost, i) in value">
      <div :key="`external-key-${i}`" class="col-12 mb-2" >
        <b-card>
          <div class="row">
            <div class="col-9 pt-1">
              <span class="section-title">{{ cost.name ? cost.name : `Costo esterno ${i + 1}`}}</span>
            </div>
            <div class="col-3 text-right">
              <button size="sm" v-b-toggle="`collapse-external-costs-${i}`" type="button" class="btn btn-outline-primary mr-3">
                Dettagli
                <b-icon-chevron-up class="ml-2 when-open"></b-icon-chevron-up>
                <b-icon-chevron-down class="ml-2 when-closed"></b-icon-chevron-down>
              </button>
            </div>
          </div>
        </b-card>

        <b-collapse :id="`collapse-external-costs-${i}`">
          <b-card>
            <div class="col-12 text-right" :key="'cost-action-' + i">
              <ActionDelete @click="removeCost(i)" />
            </div>
            <FormInputProjectExternalCostWidget
              class="col-12"
              :value="cost"
              :firstMonth="firstMonth"
              @input="updateCost(i, $event)"
              :key="'cost-' + i"
            />
            <div class="col-12 text-right" :key="'cost-hr-' + i">
              <hr class="d-block mb-4">
            </div>
          </b-card>
        </b-collapse>
      </div>
    </template>
    <div v-if="value.length > 0" class="col-12 text-right">
      <button class="btn btn-secondary mb-3" type="button" @click.prevent="addCost" v-if="value.length > 4">Aggiungi costo</button>
      <button v-if="libraryCosts.length > 0" class="btn btn-secondary ml-3 mb-3" type="button" @click.prevent="addCostFromLibrary">Aggiungi costo da libreria</button>
    </div>
    <BModal title="Aggiungi costo da libreria" dialog-class="modal--type-dialog" id="pick-library-cost" ref="pick-library-cost" hide-footer centered scrollable>
      <form @submit.prevent="doAddLibraryCost">
        <div class="form-group row align-items-end py-4">
          <div class="col">
            <FormInputSelect
              v-model="libraryCostToUse"
              :options="libraryCosts"
              optionLabel="name"
              optionValue="id"
            />
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-primary" type="submit">Aggiungi</button>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script>
import Vue from 'vue';
import { BIconChevronUp, BIconChevronDown, VBToggle, BCollapse, BCard, BModal } from 'bootstrap-vue';

Vue.directive('b-toggle', VBToggle);
export default {
  components: {
    BIconChevronDown,
    BIconChevronUp,
    BModal,
    BCollapse,
    BCard,
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    FormInputProjectExternalCostWidget: () => import('./FormInputProjectExternalCostWidget'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    FormInputSelect: () => import('@/libs/Form/components/Inputs/FormInputSelect'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Costi esterni',
    },
    firstMonth: {},
    libraryCosts: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      libraryCostToUse: null,
    };
  },
  methods: {
    emitValue (newValue) {
      this.$emit('input', newValue);
    },
    addCost () {
      const newValue = [...this.value];
      newValue.push({
        name: null,
        measurementUnit: null,
        unitCost: null,
        vat: null,
        ritenuta: null,
        quantity: 1,
        fatturazioni: [],
      });

      this.emitValue(newValue);
    },
    addCostFromLibrary () {
      if (this.libraryCosts.length === 0) {
        return;
      }

      this.libraryCostToUse = null;
      this.$refs['pick-library-cost'].show();
    },
    doAddLibraryCost () {
      const libraryCost = this.libraryCosts.find(lc => lc.id === this.libraryCostToUse);

      const newValue = [...this.value];

      newValue.push({
        name: libraryCost.name,
        measurementUnit: libraryCost.measurementUnit,
        unitCost: libraryCost.unitCost,
        vat: libraryCost.vat,
        ritenuta: libraryCost.ritenuta,
        quantity: 1,
        fatturazioni: [],
      });

      this.emitValue(newValue);
      this.$refs['pick-library-cost'].hide();
      this.libraryCostToUse = null;
    },
    removeCost (rowNumber) {
      this.emitValue((this.value || []).filter((r, i) => i !== rowNumber));
    },
    updateCost (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          return value;
        }

        return r;
      }));
    },
  },
};

</script>

<style lang="scss" scoped>
.piano-external-cost-control {
  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }
}
</style>
